/**
 * Copyright 2026 Bluecircle Technologies Pvt Limited. All rights reserved.
 *
 * This software and its source code are the proprietary and confidential
 * intellectual property of Bluecircle Technologies Pvt Limited. Unauthorized
 * copying, reproduction, distribution, modification, public display, or use
 * of this software, in whole or in part, is strictly prohibited without the
 * prior written permission of Bluecircle Technologies Pvt Limited.
 *
 * Portions derived from Grist (Copyright Grist Labs), used under the Apache
 * License, Version 2.0. See the NOTICE file for details.
 */

import { localStorageJsonObs } from "app/client/lib/localStorageObs";
import { getGristConfig } from "app/common/urlUtils";

import { Observable } from "grainjs";

let _PERMITTED_CUSTOM_WIDGETS: Observable<string[]> | undefined;

export function PERMITTED_CUSTOM_WIDGETS(): Observable<string[]> {
  if (!_PERMITTED_CUSTOM_WIDGETS) {
    _PERMITTED_CUSTOM_WIDGETS =
      localStorageJsonObs("PERMITTED_CUSTOM_WIDGETS", getGristConfig().permittedCustomWidgets || []);
  }
  return _PERMITTED_CUSTOM_WIDGETS;
}
